import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CardModule, FormModule, GridModule, ModalModule } from '@coreui/angular';
import { IconModule } from '@coreui/icons-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AppSharedModule } from '../../shared/app.shared-module';

// Componentes del modal
import { TicketModalComponent } from './ticket-modal.component';
import { FormEventoComponent } from './form-evento/form-evento.component';
import { FormTicketComponent } from './form-ticket/form-ticket.component';
import { TablaProductosTicketComponent } from './form-ticket/tabla-productos-ticket/tabla-productos-ticket.component';
import { TablaServiciosTicketComponent } from './form-ticket/tabla-servicios-ticket/tabla-servicios-ticket.component';
import { DetalleTicketComponent } from './detalle-ticket/detalle-ticket.component';
import { TicketResumenDetalleComponent } from './ticket-resumen-detalle/ticket-resumen-detalle.component';

@NgModule({
  imports: [
    CommonModule,
    NgSelectModule,
    AlertModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    GridModule,
    FormModule,
    IconModule,
    ModalModule,
    AppSharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    TicketModalComponent,
    FormEventoComponent,
    FormTicketComponent,
    TablaServiciosTicketComponent,
    TablaProductosTicketComponent,
    DetalleTicketComponent,
    TicketResumenDetalleComponent,
  ],
  exports: [
    TicketModalComponent,
    TicketResumenDetalleComponent
  ]
})
export class TicketModalModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
